import { createStore }  from 'vuex'
import adminStore       from './modules/admin'
import sectionStore     from './modules/section'
import brandedStore     from './modules/branded'
import searchStore      from './modules/search'
import lastnewsStore    from './modules/lastnews'
import videosStore      from './modules/videos'
import {clientPlugin}   from './plugins/client'

export function getStore ()
{
    return createStore({
        modules: {
            admin: adminStore,
            section: sectionStore,
            branded: brandedStore,
            search: searchStore,
            lastnews: lastnewsStore,
            videos: videosStore
        },
        strict: false,
        plugins: [
            clientPlugin
        ],
        preserveState: true
    })
}
